<template>
<div class="row justify-content-center align-items-center font-weight-bold">
  <p class="logout-text">ログアウトしました。</p>  
</div>
</template>

<script>
import {logout} from '@/api/auth';

import firebase from 'firebase/app';
import {
  getUserId, removeUserId,
  getLogged, removeLogged,
  getAuthenResponse, removeAuthenResponse,
  getUserInfo, removeUserInfo
} from '@/utils/auth';
import {
  getState, removeState,
  getCampaignCautions, removeCampaignCautions,
  getPrize, removePrize,
} from '@/utils/campaign';

import {config} from '../firebaseConfig';

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}else {
  firebase.app();
}

export default {
  name: "Logout",

  created() {
    // Remove token from cookies
    if (getLogged()) {
      logout();
      removeLogged();
    }

    // Remove campaign state from cookies
    if (getState()) {
      removeState();
    }

    // Remove authen response from cookies
    if (getAuthenResponse()) {
      removeAuthenResponse();
    }

    // remove prize from cookies if available
    if (getPrize()) {
      removePrize();
    }

    // remove campaign cautions from cookies if available
    if (getCampaignCautions()) {
      removeCampaignCautions();
    }

    // Remove user id from cookies
    if (getUserId()) {
      removeUserId();
    }

    // Remove user info from cookies
    if (getUserInfo()) {
      removeUserInfo();
    }

    firebase.auth().signOut();
  }
}
</script>

<style scoped>
  .logout-text {
    font-size: 1.3rem !important;
    color: #4b579f !important;
    margin-top: 280px
  }
</style>
